const tabs = document.querySelectorAll(".js-tabs")

tabs.forEach(tab => {
  setTab(tab)
})

const tabsObserver = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if(mutation.type==="childList") {
      setTab(mutation.target)
    }
  })
});

tabs.forEach(tab => {
  tabsObserver.observe(tab, {childList: true, subtree: true})
})


function setTab(tab) {
  const links = tab.querySelectorAll(".js-tabs__tab")
  const contents = tab.querySelectorAll(".js-tabs__content")

  const closeAllContents = () => contents.forEach(content => content.classList.remove("--active"))
  const resetAllLinks = () => links.forEach(link => link.classList.remove("--active"))

  links.forEach(link => {
    link.addEventListener("click", (event) => {
      event.preventDefault()

      if (link.classList.contains("--active")) return

      const targetId = link.getAttribute("data-tab-target") ?? ""
      const targetContent = document.getElementById(targetId)

      if (targetContent === null) return

      closeAllContents()
      resetAllLinks()
      targetContent.classList.add("--active")
      link.classList.add("--active")

    })
  })
}
